import React, { useState } from "react";
import { SingleDatePicker } from "react-dates";
import moment from "moment";
import classNames from "classnames";

import Checkbox from "../Checkbox";
import ElementModal from "./ElementModal";
import Row from "../Layout/Row";
import style from './_modal.module.scss';


export default function CloseAlertModal({ isOpen, onClose, onSubmit, agrismartType }) {
	let className = classNames(style.modal, style.closeAlertModal);

	let [customDate, setCustomDate] = useState()
	let [customDateFocused, setCustomDateFocused] = useState();
	let [silUntil, setSilUntil] = useState()

	return (
		<ElementModal isOpen={isOpen} onClose={onClose} className={className} submit={() => onSubmit(silUntil)}>
			<div className={style.section}>
				<div className={style.title}>Chiudi alert</div>
				<Row>
					<Checkbox
						checked={!customDate && !silUntil}
						onCheck={() => setSilUntil(null)}
					/>
					{"Chiudi Alert"}
				</Row>
				<Row>
					<Checkbox
						checked={!customDate && moment().add(3, "days").format("YYYY-MM-DD") === silUntil}
						onCheck={() => setSilUntil(moment().add(3, "days").format("YYYY-MM-DD"))}
					/>
					{`Chiudi e silenzia alert di questo tipo per 3 giorni${agrismartType ? " (trattamento di copertura)" : ""}`}
				</Row>
				<Row>
					<Checkbox
						checked={!customDate && moment().add(7, "days").format("YYYY-MM-DD") === silUntil}
						onCheck={() => setSilUntil(moment().add(7, "days").format("YYYY-MM-DD"))}
					/>
					{"Chiudi e silenzia alert di questo tipo per una settimana"}
				</Row>
				<Row>
					<Checkbox
						checked={!customDate && moment().add(10, "days").format("YYYY-MM-DD") === silUntil}
						onCheck={() => setSilUntil(moment().add(10, "days").format("YYYY-MM-DD"))}
					/>
					{`Chiudi e silenzia alert di questo tipo per 10 giorni${agrismartType ? " (trattamento con sistemico)" : ""}`}
				</Row>
				<Row>
					<Checkbox
						checked={!customDate && moment().add(1, "months").format("YYYY-MM-DD") === silUntil}
						onCheck={() => setSilUntil(moment().add(1, "months").format("YYYY-MM-DD"))}
					/>
					{"Chiudi e silenzia alert di questo tipo per un mese"}
				</Row>
				<Row>
					<Checkbox
						checked={customDate && customDate.format("YYYY-MM-DD") === silUntil}
						onCheck={c => setCustomDateFocused(c)}
					/>
					{"Chiudi e silenzia alert di questo tipo fino a "}
					<>&nbsp;</>
					<SingleDatePicker
						date={customDate} // momentPropTypes.momentObj or null
						onDateChange={date => {
							setCustomDate(date);
							setSilUntil(date && date.format("YYYY-MM-DD"))
							setCustomDateFocused(false)
						}} // PropTypes.func.isRequired
						focused={customDateFocused} // PropTypes.bool
						onFocusChange={({ focused }) => setCustomDateFocused(focused)} // PropTypes.func.isRequired
						id="custom_date" // PropTypes.string.isRequired,
						displayFormat={"DD/MM/YYYY"}
						isOutsideRange={(o) => o.isBefore(moment(), 'day')}
						showClearDate
						reopenPickerOnClearDate={false}
						small
						placeholder={"Scegli..."}
					/>
				</Row>
			</div>
		</ElementModal>
	)

}
